// extracted by css-extract-rspack-plugin
export default {"root":"Camera_root__4kIwE","img":"Camera_img__8r6ab","video":"Camera_video__bWROg","imageMirror":"Camera_imageMirror__Lzsf9","invis":"Camera_invis__gAW70"};